import { defineAction } from '~/prix'
import { z } from 'zod'
import roadMaintenanceCreateAction from './roadMaintenanceCreate.action.json' with { type: 'json' }
import { roadMaintenanceObject } from '../roadMaintenanceObject'
import { operatorObject } from '../../operator/operatorObject'
import { materialObject } from '../../material/materialObject'
import { heavyMachineryObject } from '../../heavyMachinery/heavyMachineryObject'

const roadMaintenanceCreateDefinition = defineAction({
  ...roadMaintenanceCreateAction,

  input: roadMaintenanceObject
    .pick({
      id: true,
      scheduledDate: true,
      communityId: true,
      street: true,
      serviceLocation: true,
      lengthMeters: true,
      responsibleCitizenId: true,
      status: true,
      observations: true,
    })
    .partial({ id: true })
    .extend({
      machineUsages: z.array(
        z.object({
          heavyMachineryId: heavyMachineryObject.shape.id,
          operatorId: operatorObject.shape.id.nullish(),
          startTime: z.string().nullish(),
          endTime: z.string().nullish(),
        }),
      ),
      materials: z.array(materialObject.shape.id),
    }),

  output: z.object({ id: z.string().uuid() }),
})

export default roadMaintenanceCreateDefinition
